import { defineMessages } from "react-intl";
const messages = defineMessages({
    popularAmenitiesTitle: {
        id: "app.aiDiscoverability.customSubtopics.amenitiesTab.popularAmenities.title",
        defaultMessage: "Popular Amenities",
    },
    popularAmenitiesSubtitle: {
        id: "app.aiDiscoverability.customSubtopics.amenitiesTab.popularAmenities.subtitle",
        defaultMessage: 'How these are used: "Apartments with [rooftop deck] near me"',
    },
    fixedAmenitiesTitle: {
        id: "app.aiDiscoverability.customSubtopics.amenitiesTab.fixedAmenities.title",
        defaultMessage: "Fixed Amenities the area",
    },
    fixedAmenitiesSubtitle: {
        id: "app.aiDiscoverability.customSubtopics.amenitiesTab.fixedAmenities.subtitle",
        defaultMessage: 'How these are used: "1 Bedroom apartments near me with a [fitness center]"',
    },
});
export default messages;
